/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_HomeInputs */

const en_err_home = /** @type {(inputs: Err_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const id_err_home = /** @type {(inputs: Err_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke beranda`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Err_HomeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const err_home = /** @type {((inputs?: Err_HomeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_HomeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_err_home(inputs)
	return en_err_home(inputs)
});